import React, { useState } from "react";
import Button from "../../..//Elements/Button/Button.js";
import classNames from "classnames";
import Icon from "../../../Elements/Icon/Icon.tsx";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { decode } from "html-entities";
import {
  FacebookShareButton,
  FacebookIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon,
  RedditShareButton,
  RedditIcon,
  TelegramShareButton,
  TelegramIcon,
  TumblrShareButton,
  TumblrIcon,
  TwitterShareButton,
  TwitterIcon,
  VKShareButton,
  VKIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import config from "config.ts";

const SocialIcons = ({
  setShareMailForm,
  setIsShareViaLink,
  mailLink,
  isShareViaLink,
}) => {
  const { getTextByKey, getBasicSettingsData } = useContent();
  const { getMailMetaData } = useMail();
  //social media configurations
  const hashtags = getTextByKey("social-media-share-hashtags").split(",");
  const title =
    getMailMetaData() && getMailMetaData().subjectText
      ? decode(getMailMetaData().subjectText)
      : getTextByKey("social-media-share-title");
  const summary = getTextByKey("social-media-share-summary");
  const source = "JUMBOmail.me";
  const image = `${config.api.resource}/assets/images/jumbomail-logo-black.svg`;

  //show more button logic
  const [isShowMore, setIsShowMore] = useState(false);
  const showMoreClass = classNames(
    "share-icons-container ",
    isShowMore ? "container-height-expended" : ""
  );

  return (
    <div className={showMoreClass}>
      <Tooltip id="share-link-id" tooltipTextKey={"share-via-link"}>
        <Button
          roundicon
          gray
          onClick={() => {
            setIsShareViaLink(true);
            setShareMailForm(false);
          }}
          buttonClass={isShareViaLink ? "selected" : ""}
        >
          <Icon name="share-link" />
        </Button>
      </Tooltip>
      <Tooltip id="share-mail-id" tooltipTextKey={"share-via-mail"}>
        <Button
          roundicon
          onClick={() => {
            setIsShareViaLink(false);
            setShareMailForm(true);
          }}
          buttonClass={!isShareViaLink ? "selected" : ""}
        >
          <Icon name={"envelope-solid"} />
        </Button>
      </Tooltip>
      <Tooltip id="share-fb-id" tooltipTextKey={"Facebook"}>
        <FacebookShareButton url={mailLink} quote={title} hashtag={hashtags}>
          <FacebookIcon size={44} round />
        </FacebookShareButton>
      </Tooltip>
      <Tooltip id="share-whatsapp-id" tooltipTextKey={"Whatsapp"}>
        <WhatsappShareButton
          url={mailLink}
          title={title}
          windowWidth={window.innerWidth / 1.5}
          windowHeight={window.innerHeight / 1.5}
        >
          <WhatsappIcon size={44} round />
        </WhatsappShareButton>
      </Tooltip>
      {/* show more button */}
      {!isShowMore ? (
        <Tooltip id="share-show-more-id" tooltipTextKey={"show-more"}>
          <Button red roundicon onClick={() => setIsShowMore(true)}>
            <Icon name="plus" />
          </Button>
        </Tooltip>
      ) : (
        <>
          <Tooltip id="share-messenger-id" tooltipTextKey={"Messenger"}>
            <FacebookMessengerShareButton
              url={mailLink}
              quote={title}
              hashtag={hashtags}
              appId={getBasicSettingsData().facebookAppId}
            >
              <FacebookMessengerIcon
                size={44}
                round
                className="share-icon-faded"
              />
            </FacebookMessengerShareButton>
          </Tooltip>
          <Tooltip id="share-linkedin-id" tooltipTextKey={"Linkedin"}>
            <LinkedinShareButton
              url={mailLink}
              title={title}
              summary={summary}
              source={source}
            >
              <LinkedinIcon size={44} round className="share-icon-faded" />
            </LinkedinShareButton>
          </Tooltip>
          <Tooltip id="share-pinterest-id" tooltipTextKey={"Pinterest"}>
            <PinterestShareButton
              url={mailLink}
              description={summary}
              media={image}
            >
              <PinterestIcon size={44} round className="share-icon-faded" />
            </PinterestShareButton>
          </Tooltip>
          <Tooltip id="share-reddit-id" tooltipTextKey={"Reddit"}>
            <RedditShareButton url={mailLink} title={title}>
              <RedditIcon size={44} round className="share-icon-faded" />
            </RedditShareButton>
          </Tooltip>
          <Tooltip id="share-telegram-id" tooltipTextKey={"Telegram"}>
            <TelegramShareButton url={mailLink} title={title}>
              <TelegramIcon size={44} round className="share-icon-faded" />
            </TelegramShareButton>
          </Tooltip>
          <Tooltip id="share-tumblr-id" tooltipTextKey={"Tumblr"}>
            <TumblrShareButton url={mailLink} title={title} caption={summary}>
              <TumblrIcon size={44} round className="share-icon-faded" />
            </TumblrShareButton>
          </Tooltip>
          <Tooltip id="share-twitter-id" tooltipTextKey={"Twitter"}>
            <TwitterShareButton
              url={mailLink}
              title={title}
              hashtags={hashtags.map((item) =>
                item.includes("#") ? item.split("#")[1] : item
              )}
            >
              <TwitterIcon size={44} round className="share-icon-faded" />
            </TwitterShareButton>
          </Tooltip>
          <Tooltip id="share-vk-id" tooltipTextKey={"VK"}>
            <VKShareButton url={mailLink} title={title} image={image}>
              <VKIcon size={44} round className="share-icon-faded" />
            </VKShareButton>
          </Tooltip>
        </>
      )}
    </div>
  );
};
export default SocialIcons;
